export default "__VITE_ASSET__BUCEBxCA__"